<div class="information-html-container" >
	<div class="information-html-container--icon-container">
		<i class="{{iconType}}"></i>
	</div>
  <div [innerHTML]="safeHtml"></div>
</div>
